var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightGifts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 15,
  fill: "currentColor",
  viewBox: "0 0 20 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13 .5-1.41 1.41 4.58 4.59H0v2h16.17l-4.59 4.59L13 14.5l7-7z"
})));
export default SvgArrowRightGifts;